import Button from "@/components/bricks/button/Button";
import { StickyFooter } from "../../stickyFooter/modalStickyFooter";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../select/Select";
import { FormikProps } from "formik";
import {
  OpretKursusLinjeStep1Formik,
  OpretKursusLinjeStep2Formik,
} from "./useOpretKursusLinje";
import { TextInputFormik } from "../../formcontrols/InputItem";
import { FormikDatePicker } from "../../formcontrols/DatePicker";
import ValidationErrorMessage from "../../formcontrols/ValidationErrorMessage";
import FormikTimePicker from "../../formcontrols/TimePicker";
import IsRequired from "../../formcontrols/common/IsRequired";

export default function OpretLinjeStep2(props: {
  step1: FormikProps<OpretKursusLinjeStep1Formik>;
  step2: FormikProps<OpretKursusLinjeStep2Formik>;
  setStep: React.Dispatch<
    React.SetStateAction<1 | 2 | "kursuskvittering" | "linjekvittering">
  >;
  isPosting: boolean;
  fmuKursusKategorier: KodeListe[];
}) {
  const { setStep, step2, isPosting, fmuKursusKategorier } = props;

  return (
    <>
      <form autoComplete="off" onSubmit={step2.handleSubmit}>
        <fieldset disabled={isPosting}>
          <div className="c-modal-container-inner c-modal-container-inner--lg">
            <h3 className="mb-4 mt-n2">Opret kurser</h3>
            <ol className="list-group list-group-numbered">
              <ListGroupItem
                step2={step2}
                i={1}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={2}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={3}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={4}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={5}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={6}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={7}
                fmuKursusKategorier={fmuKursusKategorier}
              />
              <ListGroupItem
                step2={step2}
                i={8}
                fmuKursusKategorier={fmuKursusKategorier}
              />
            </ol>
          </div>
          <StickyFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setStep(1);
              }}
            >
              Forrige
            </Button>

            <Button type="submit" color="primary">
              Opret linje
            </Button>
          </StickyFooter>
        </fieldset>
      </form>
    </>
  );
}

const ListGroupItem = (props: {
  step2: FormikProps<OpretKursusLinjeStep2Formik>;
  i: number;
  fmuKursusKategorier: KodeListe[];
}) => {
  const { step2, i, fmuKursusKategorier } = props;
  const { values, errors, touched, setFieldTouched, setFieldValue } = step2;

  const formik = {
    values: values.kurser[i],
    handleBlur: (e) => {
      setFieldTouched(`kurser[${i}][${e.target.id}]`, true);
    },
    handleChange: (e) => {
      setFieldValue(`kurser[${i}][${e.target.id}]`, e.target.value, true);
      setFieldTouched(`kurser[${i}][${e.target.id}]`, true);
    },
    setFieldValue: (field, value) => {
      setFieldValue(`kurser[${i}].${field}`, value, true);
    },
    setFieldTouched: (field, value) => {
      setFieldTouched(`kurser[${i}].${field}`, value, true);
    },
    errors: errors.kurser ? (errors.kurser[i] ? errors.kurser[i] : {}) : {},
    touched: touched.kurser ? (touched.kurser[i] ? touched.kurser[i] : {}) : {},
  };

  return (
    <li
      className="list-group-item row d-flex ps-6 pt-3 pb-4 flex-lg-nowrap"
      style={{ gap: "1rem 0" }}
    >
      <div className="col-6 col-lg-2">
        <TextInputFormik
          performant
          config={{
            component: "textinput",
            id: "navn",
            label: "Navn",
            isRequired: true,
            initialValue: step2.initialValues.kurser[i].navn,
          }}
          formik={formik as FormikProps<any>}
        />
      </div>
      <div className="col-6 col-lg-3">
        <label className="form-label">
          Kategori <IsRequired />
        </label>
        <Select
          onValueChange={(val) => {
            step2.setFieldValue(`kurser[${i}].kursuskategori`, val);
          }}
          value={values.kurser[i].kursuskategori}
        >
          <SelectTrigger
            aria-label="Vælg kategori"
            placeholder="Vælg kategori"
            className={`c-select__trigger--truncate${
              errors.kurser &&
              errors.kurser[i] &&
              errors.kurser[i].kursuskategori
                ? " is-invalid"
                : ""
            }`}
          />
          <SelectContent scrollable>
            {fmuKursusKategorier.map((t) => (
              <SelectItem key={t.nr} value={t.nr as any}>
                {t.navn}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <ValidationErrorMessage
          touched={true}
          errorMessage={
            errors.kurser && errors.kurser[i] && errors.kurser[i].kursuskategori
          }
        />
      </div>
      <div className="col-6 col-lg-2">
        <FormikDatePicker
          formik={formik as FormikProps<any>}
          config={{
            initialValue: "",
            component: "datepicker",
            id: "fraDato",
            label: "Startdato",
            isRequired: true,
          }}
        />
      </div>
      <div className="col-6 col-lg-auto flex-lg-grow-1">
        <FormikTimePicker
          formik={formik as FormikProps<any>}
          placeholder="--:--"
          config={{
            placeholder: "--:--",
            component: "timepicker",
            id: "fraKlDag",
            label: "Starttidspunkt",
            isRequired: true,
          }}
        />
      </div>
      <div className="col-6 col-lg-2">
        <FormikDatePicker
          formik={formik as FormikProps<any>}
          config={{
            initialValue: "",
            component: "datepicker",
            id: "tilDato",
            label: "Slutdato",
            isRequired: true,
          }}
        />
      </div>
      <div className="col-6 col-lg-auto flex-lg-grow-1">
        <FormikTimePicker
          formik={formik as FormikProps<any>}
          placeholder="--:--"
          config={{
            placeholder: "--:--",
            component: "timepicker",
            id: "tilKlDag",
            label: "Sluttidspunkt",
            isRequired: true,
          }}
        />
      </div>
    </li>
  );
};
